<div class="row" style="margin: 20px 20px 20px 20px;">
  <fdb-list-academicpartner></fdb-list-academicpartner>
  <fdb-list-enbw-unit></fdb-list-enbw-unit>
</div>
